export default __webpack_public_path__ + "static/media/DP_CF_Fr.4d79b471.pdf";